import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, string_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { JS_blurActiveElement, JS_runAfter } from "../UI.js";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import { equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty, singleton, append, delay as delay_2, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { icon } from "./Icon.js";
import check from "@iconify-icons/fa6-solid/check";
import { TranslationPages_Home__get_Theme, AppTranslations__get_Home, TranslationPages_Home__get_ThemeGroup, AppTranslations__get_IsEmpty } from "../Shopfoo.Shared/Translations.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import brush from "@iconify-icons/fa6-solid/brush";

class ThemeGroup extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Dark", "Light"];
    }
}

function ThemeGroup_$reflection() {
    return union_type("Shopfoo.Client.Components.Theme.ThemeGroup", [], ThemeGroup, () => [[], []]);
}

export class Theme extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Dark", "Light", "Business", "Corporate", "Garden", "Night", "Nord", "Dim"];
    }
}

export function Theme_$reflection() {
    return union_type("Shopfoo.Client.Components.Theme.Theme", [], Theme, () => [[], [], [], [], [], [], [], []]);
}

class Emoji extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["Emoji"];
    }
}

function Emoji_$reflection() {
    return union_type("Shopfoo.Client.Components.Theme.Emoji", [], Emoji, () => [[["Item", string_type]]]);
}

function keyOf(x) {
    return (`${x}`).toLowerCase();
}

export function Theme__ApplyOnHtml_Z12EEBC6C(theme, delay) {
    JS_runAfter(defaultArg(delay, 0), () => {
        document.documentElement.setAttribute("data-theme", keyOf(theme));
    });
}

class ThemeMenu {
    constructor(currentTheme, onClick) {
        this.currentTheme = currentTheme;
        this.onClick = onClick;
    }
}

function ThemeMenu_$reflection() {
    return class_type("Shopfoo.Client.Components.Theme.ThemeMenu", undefined, ThemeMenu);
}

function ThemeMenu_$ctor_Z179A9F56(currentTheme, onClick) {
    return new ThemeMenu(currentTheme, onClick);
}

function ThemeMenu__group(_, themeGroup, text) {
    return createElement("li", createObj(Helpers_combineClasses("menu-title", ofArray([["key", `${keyOf(themeGroup)}-theme-group`], ["children", text]]))));
}

function ThemeMenu__item(_, theme, _arg, text) {
    let elems_2, elems_1, elems;
    const key = keyOf(theme);
    const isSelected = equals(theme, _.currentTheme);
    const previewBadge = (letter, colorName, colorProp) => createElement("div", createObj(Helpers_combineClasses("badge", ofArray([["className", "badge-xs"], colorProp, ["key", `${key}-theme-badge-${colorName}`], ["className", "mr-0.5 px-1"], ["children", `${letter}`], ["title", colorName]]))));
    return createElement("li", createObj(ofArray([["key", `${key}-theme`], ["className", "aria-selected:bg-base-300 rounded"], ["aria-selected", isSelected], (elems_2 = [createElement("a", createObj(ofArray([["key", `${key}-theme-link`], ["className", "whitespace-nowrap"], ["onClick", (_arg_1) => {
        _.onClick(theme);
        JS_blurActiveElement();
    }], (elems_1 = [createElement("span", {
        key: `${key}-theme-emoji`,
        children: _arg.fields[0],
    }), createElement("span", {
        key: `${key}-theme-name`,
        className: "flex-1 mx-1",
        children: text,
    }), createElement("span", createObj(ofArray([["key", `${key}-theme-text`], ["className", "inline-flex items-center p-1 rounded"], ["data-theme", key], (elems = [previewBadge("1", "base-100", ["className", "bg-base-100"]), previewBadge("2", "base-200", ["className", "bg-base-200"]), previewBadge("3", "base-300", ["className", "bg-base-300"]), previewBadge("P", "primary", ["className", "badge-primary"]), previewBadge("S", "secondary", ["className", "badge-secondary"]), previewBadge("A", "accent", ["className", "badge-accent"]), previewBadge("N", "neutral", ["className", "badge-neutral"])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("span", createObj(toList(delay_2(() => append(singleton(["key", `${key}-theme-tick`]), delay_2(() => append(singleton(["className", "font-bold text-green-500 min-w-[1em] text-right"]), delay_2(() => (isSelected ? singleton(["children", icon(check)]) : empty())))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function ThemeDropdown(themeDropdownInputProps) {
    let elems_2, elems_1, elems;
    const onClick = themeDropdownInputProps.onClick;
    const translations = themeDropdownInputProps.translations;
    const theme = themeDropdownInputProps.theme;
    const key = themeDropdownInputProps.$key;
    if (AppTranslations__get_IsEmpty(translations)) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(Helpers_combineClasses("dropdown", ofArray([["className", "dropdown-hover"], ["className", "dropdown-end"], ["key", `${key}-dropdown`], ["className", "flex-none"], (elems_2 = [createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-ghost"], ["key", "theme-button"], ["className", "opacity-80 hover:opacity-100"], ["children", icon(brush)]])))), createElement("ul", createObj(Helpers_combineClasses("dropdown-content", ofArray([["key", "theme-dropdown-content"], ["className", "p-2 shadow menu bg-base-100 rounded-box"], ["tabIndex", 0], (elems_1 = [createElement("ul", createObj(ofArray([["key", "theme-dropdown-list"], (elems = toList(delay_2(() => {
            const themeMenu = ThemeMenu_$ctor_Z179A9F56(theme, onClick);
            return append(singleton(ThemeMenu__group(themeMenu, new ThemeGroup(1, []), TranslationPages_Home__get_ThemeGroup(AppTranslations__get_Home(translations)).Light)), delay_2(() => append(singleton(ThemeMenu__item(themeMenu, new Theme(1, []), new Emoji("🌞"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Light)), delay_2(() => append(singleton(ThemeMenu__item(themeMenu, new Theme(3, []), new Emoji("🏢"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Corporate)), delay_2(() => append(singleton(ThemeMenu__item(themeMenu, new Theme(4, []), new Emoji("🧑‍🌾"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Garden)), delay_2(() => append(singleton(ThemeMenu__item(themeMenu, new Theme(6, []), new Emoji("⛰️"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Nord)), delay_2(() => append(singleton(ThemeMenu__group(themeMenu, new ThemeGroup(0, []), TranslationPages_Home__get_ThemeGroup(AppTranslations__get_Home(translations)).Dark)), delay_2(() => append(singleton(ThemeMenu__item(themeMenu, new Theme(0, []), new Emoji("🌚"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Dark)), delay_2(() => append(singleton(ThemeMenu__item(themeMenu, new Theme(2, []), new Emoji("💼"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Business)), delay_2(() => append(singleton(ThemeMenu__item(themeMenu, new Theme(5, []), new Emoji("🌃"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Night)), delay_2(() => singleton(ThemeMenu__item(themeMenu, new Theme(7, []), new Emoji("🔅"), TranslationPages_Home__get_Theme(AppTranslations__get_Home(translations)).Dim))))))))))))))))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
    }
}

